import Vue, { PluginFunction } from 'vue'

import BaseTemplate from '../BaseTemplateUtil'
import CommercePlugin from '../Commerce'
import registerRoutes from './NewConfig/processRoutes'
import PostApi from './includes/logic/Api/PostApi'
import { AdminTemplateOptions } from './includes/types/Config'
import setRouteGuards from './routeGuards'
import AdminTemplateModule from './store'

function processOptions(options: AdminTemplateOptions): void {
  Vue.prototype.$templateRouter = options.router

  // set layout save button
  if (options.config.meta && options.config.meta.isSaveButtonVisible !== undefined) {
    options.store.dispatch('AdminTemplate/showSaveConfigButton')
  } else {
    options.store.dispatch('AdminTemplate/hideSaveConfigButton')
  }

  // process routes from application config and default routes from template to set them to VueRouter
  registerRoutes(options)

  // define VueRouter global guards
  setRouteGuards(options.store, options.router, options.i18n)

  // set config parts to store
  options.store.commit('AdminTemplate/SET_PROJECT_CONFIG', { config: options.config })
  options.store.commit('AdminTemplate/SET_ROUTES', options.config.sidebar)
  options.store.commit('AdminTemplate/SET_LANGUAGES', { languageCodes: options.config.meta.languageCodes })
}

// eslint-disable-next-line complexity,max-statements
export default function (vue: Vue, options: AdminTemplateOptions): void {
  Vue.use(CommercePlugin as unknown as PluginFunction<any>, { store: options.store })
  Vue.use(BaseTemplate, { store: options.store })

  if (
    !options
    || !options.store
    || !options.router
    || !options.config.meta
    || !options.config.meta.languageCodes
  ) {
    throw new Error('Please initialise plugin with valid options.')
  }

  if (!options.store.hasModule('AdminTemplate')) {
    options.store.registerModule('AdminTemplate', AdminTemplateModule)
  } else {
    throw new Error('AdminTemplate module error: module already exists')
  }

  processOptions(options)

  const Api = new PostApi(options.config.meta.apiUrl)

  options.store.commit('AdminTemplate/LOADED')
}
